const VaultMessages = {
  HasBwInstalled: "hasBwInstalled",
  checkBwInstalled: "checkIfBWExtensionInstalled",
  OpenAtRiskPasswords: "openAtRiskPasswords",
  PopupOpened: "popupOpened",
} as const;

export { VaultMessages };
